<template>
  <div class="ListApiClient">
    <HeaderPage>
      <el-button style="height: 44px; margin-left: 1rem" @click="dialogEditAdd = true">Adicionar</el-button>
    </HeaderPage>
    <el-card v-loading="loadingPage">
      <TableSimple :list-data="listData" @paginationClick="paginationClick">
        <el-table-column prop="id" label="#" width="80">
        </el-table-column>
        <el-table-column prop="user.name" label="Nome">
        </el-table-column>
        <el-table-column prop="type" label="Tipo">
        </el-table-column>
        <el-table-column width="55">
          <template slot-scope="scope">
            <el-button type="text" @click="openDialog(scope.row.id)">
              <EditIcon size="1.2x" style="padding: 0 7px;"></EditIcon>
            </el-button>
          </template>
        </el-table-column>
      </TableSimple>

      <dialogEditAddApiClient :show="dialogEditAdd" :idConta="idConta" @close="closeDialog" />
    </el-card>
  </div>
</template>

<script>
import HeaderPage from "@/app/components/HeaderPage";
import TableSimple from "@/app/components/Table/TableSimple";
import {EditIcon, XIcon} from "vue-feather-icons";
import {getApiClient, getBank} from "@/app/domains/Config/services";
import dialogEditAddApiClient from "@/app/domains/Config/components/ApiClient/dialogEditAddApiClient";

export default {
  name: "ListApiClient",
  components: {
    HeaderPage,
    TableSimple,
    EditIcon,
    dialogEditAddApiClient,
  },
  data () {
    return {
      dialogEditAdd: false,
      loadingPage: true,
      idConta: '',
      listData: {},
      ruleForm: {
        searchInput: ''
      },
    }
  },
  methods: {
    init() {
      this.listDados()
    },
    openDialog (id) {
      this.dialogEditAdd = true
      this.idConta = id
    },
    paginationClick (arg) {
      this.listDados('?page='+arg.page)
    },
    async listDados (query = '') {
      this.loadingPage = true
      this.error = {}
      try {
        let response = await getApiClient(query)
        this.listData = response.data
      } catch (e) {
        this.$message({
          showClose: true,
          message: 'Erro ao carregar lista',
          type: 'error'
        })
      } finally {
        this.loadingPage = false
      }
    },
    closeDialog() {
      this.idConta = ''
      this.dialogEditAdd = false
      this.init()
    },
  },
  mounted() {
    this.init()
    }
}
</script>

<style scoped>

</style>
